module.exports = __webpack_public_path__ + "img/header-cc-square-top.554dfd3d.svg";